export default "__VITE_ASSET__DQ7Ww9bQ__"